import templateUrl from './minimum-wage-review-modal.component.html'

export const MinimumWageReviewModalComponent = {
    controller: MinimumWageReviewModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

export const MinimumWageReviewModal = {
    component: "apexMinimumWageReviewModal",
    windowClass: 'xx-dialog pagespinner',
    backdrop: 'static',
    size: 'sm'
};

function MinimumWageReviewModalController() {
    'ngInject'
    const vm = this;
    vm.$onInit = $onInit;
    vm.filters = {};
    vm.pageNumber = 1;
    vm.pageSize = 15;

    vm.onClose = onClose;
    vm.filterWagePolicies = filterWagePolicies;
    vm.filterWagePolicy = filterWagePolicy;

    function $onInit() {
        vm.wagePolicies = vm.resolve.wagePolicies;
        vm.selectedOffice = vm.resolve.selectedOffice;

        if (vm.selectedOffice) {
            // Find which page the office's state is on and switch to it.
            const index = vm.wagePolicies.reduce(function (o, v, i, a) {
                return v.StateName === vm.selectedOffice.OfficeState ? i : o;
            }, 0);
            vm.pageNumber = Math.floor(index / vm.pageSize) + 1;
        }
        // Filter out city-specific policies.
        vm.wagePolicies = vm.wagePolicies.filter(function (wagePolicy) {
            return !wagePolicy.City;
        });
    }

    function onClose() {
        vm.dismiss({ $value: 'cancel' });
    }

    function filterWagePolicies(policies) {
        return policies && policies.filter(filterWagePolicy);
    }

    function filterWagePolicy(policy) {
        return containsInvariant(policy.StateName, vm.filters.StateName)
            && containsInvariant(policy.City, vm.filters.City);
    }

    function containsInvariant(wholeString, instance) {
        return !instance || (wholeString || "").toLowerCase().indexOf((instance || "").toLowerCase()) > -1;
    }
}
